<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [title]="'Suggested Maintenance'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (loaded) {
      @if (errorMessage) {
        <tidy-error-message
          [text]="errorMessage" />
      }

      @if (suggestion?.room_object) {
        <div style="display: flex; flex-wrap: wrap; gap: 20px; margin-bottom: 15px;">
          <div>
            <tidy-text [smallBody]="'Asset'" style="display: block; margin-bottom: 5px;" />
            <div style="display: flex; flex-wrap: wrap; align-items: center; gap: 5px;">
              <ion-chip class="filter-chip">
                @if (suggestion?.room_object?.model?.category?.default_icon_url) {
                  <tidy-image
                    [src]="suggestion?.room_object?.model?.category?.default_icon_url"
                    style="width: 14px; margin-right: 4px;" />
                }
                <ion-label>{{ suggestion?.room_object?.name }}</ion-label>
              </ion-chip>
            </div>
          </div>
        </div>
      }

      <tidy-card style="margin-top: 5px">
        <tidy-row class="extra-bottom-padding">
          <tidy-text [header]="suggestion?.title" />
        </tidy-row>

        @if (suggestion?.description) {
          <tidy-row class="extra-bottom-padding">
            <tidy-text [body]="suggestion?.description" />
          </tidy-row>
        }

        <div style="display: flex; gap: 15px; flex-wrap: wrap; margin-bottom: 15px;">
          @if (suggestion?.address_name) {
            <div>
              <tidy-text [smallBody]="'Property'" style="display: block; margin-bottom: 3px;" />
              <div style="display: flex; align-items: center; gap: 5px;">
                <tidy-image
                  [src]="'assets/svg/home.svg'"
                  class="body-size" />
                <tidy-text [body]="suggestion?.address_name" />
              </div>
            </div>
          }

          <div>
            <tidy-text [smallBody]="'Urgency'" style="display: block; margin-bottom: 3px;" />
            <div style="display: flex; align-items: center; gap: 5px;">
              <tidy-image
                [src]="getUrgencyIcon()"
                class="body-size" />
              <tidy-text [body]="getUrgencyLabel()" />
            </div>
          </div>

          @if (suggestion?.issue_report_type?.name) {
            <div>
              <tidy-text [smallBody]="'Type'" style="display: block; margin-bottom: 3px;" />
              <tidy-text [body]="suggestion?.issue_report_type?.name" />
            </div>
          }

          @if (suggestion?.due_date) {
            <div>
              <tidy-text [smallBody]="'Due Date'" style="display: block; margin-bottom: 3px;" />
              <div style="display: flex; align-items: center; gap: 5px;">
                <tidy-image
                  [src]="'assets/svg/calendar-outline-white.svg'"
                  class="body-size" />
                <tidy-text [body]="suggestion?.due_date | parseDateTime:'MMM d'" />
              </div>
            </div>
          }
        </div>

        @if (suggestion?.photos?.length) {
          <tidy-row>
            <tidy-text [header]="'Photos'" />
          </tidy-row>
          @for (photo of suggestion?.photos; track photo) {
            <tidy-row class="extra-bottom-padding">
              <tidy-image
                [src]="photo.photo_url"
                style="width: 100%; cursor: pointer;"
                (click)="openPhoto(photo.photo_url)" />
            </tidy-row>
          }
        }
      </tidy-card>

      <tidy-alert>
        <tidy-row class="vertical-align-center">
          <tidy-image
            [src]="'assets/svg/bulb-outline.svg'"
            class="header-size" />
          <tidy-text [body]="'This is a suggested maintenance task based on your assets and property data.'" />
        </tidy-row>
      </tidy-alert>

      <tidy-row class="extra-bottom-padding">
        <tidy-text [header]="'Accept:'" />
      </tidy-row>
      <div class="accept-buttons">
        <tidy-button
          [text]="'One time'"
          [action]="acceptOneTime.bind(this)"
          class="primary" />
        <tidy-button
          [text]="'Recurring'"
          [action]="acceptRecurring.bind(this)"
          class="primary" />
      </div>
      <tidy-row [align]="'center'" class="extra-top-padding">
        <tidy-text
          [actionBody]="'Reject Suggestion'"
          (action)="rejectSuggestion()"
          class="link red" />
      </tidy-row>

      @if (errorMessage) {
        <tidy-error-message
          [text]="errorMessage" />
      }

      <div style="height: 50px"></div>
    }
  </tidy-wrapper>
</ng-template>

@if (!windowService.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService.isDesktopRes) {
  <ng-container *ngTemplateOutlet="content" />
}
